import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2, ChevronLeft } from "lucide-react";

export default function EmailChangeConfirm() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [state, setState] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setTimeout(() => { setState("error"); setMessage("Token tidak ditemukan."); }, 0);
      return;
    }
    let mounted = true;
    api.get(`/auth/email-change/confirm?token=${encodeURIComponent(token)}`)
      .then((r) => { if (!mounted) return; setState("success"); setMessage(r.data?.message || "Email berhasil diperbarui."); })
      .catch((err) => { if (!mounted) return; setState("error"); setMessage(err?.response?.data?.detail || "Konfirmasi gagal."); });
    return () => { mounted = false; };
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-paper to-terra-50/30 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white border border-stone-200 shadow-sm p-8 text-center" data-testid="email-change-confirm">
        {state === "loading" && (<>
          <Loader2 className="h-8 w-8 text-stone-400 animate-spin mx-auto mb-3" />
          <p className="text-sm text-stone-500">Memverifikasi tautan…</p>
        </>)}
        {state === "success" && (<>
          <CheckCircle2 className="h-10 w-10 text-emerald-600 mx-auto mb-3" />
          <h1 className="font-display text-2xl font-bold text-stone-900 mb-2">Email Diperbarui</h1>
          <p className="text-sm text-stone-600 leading-relaxed">{message}</p>
        </>)}
        {state === "error" && (<>
          <XCircle className="h-10 w-10 text-red-600 mx-auto mb-3" />
          <h1 className="font-display text-2xl font-bold text-stone-900 mb-2">Konfirmasi Gagal</h1>
          <p className="text-sm text-stone-600 leading-relaxed">{message}</p>
        </>)}
        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-xs uppercase tracking-wider text-terra-700 hover:underline" data-testid="email-change-back-login">
          <ChevronLeft className="h-3 w-3" /> Login Ulang
        </Link>
      </div>
    </div>
  );
}
